import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProcessoService } from '@app/services/processo.service';
import { ProcessoAnexo } from '@app/models/processo-anexo.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-documentos-lista',
  templateUrl: './documentos-lista.component.html',
  styleUrls: ['./documentos-lista.component.scss']
})
export class DocumentosListaComponent implements OnInit {

  processoId: number;
  //lstProcessoAnexo: Array<ProcessoAnexo> = [];
  lstProcessoAnexo: Array<any> = [];
  bsModalRef: BsModalRef;
  desativaAposSolicitarArquivo: boolean = false;

  processoArquivado: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private processoService: ProcessoService,
    private toastrService: ToastrService,
    private utilitarioService: UtilitarioService
  ) { }

  ngOnInit() {
    this.router.events.subscribe(() => window.scrollTo(0, 0));

    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        // this.obter();
        this.processoService.obterDocumentos(this.processoId)
          .toPromise().then((data) => {
            this.lstProcessoAnexo = data;
          });
      });
  }

  obterSasRealizandoDownloadDocumentos(id: number) {
    this.desativaAposSolicitarArquivo = true;
    this.processoService.obterSasUrlParaDownloadDocumentos(id).subscribe((uriString) => {
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.href = uriString;
      a.protocol = "https";
      a.click();
      a.remove();
    }, (error) => {
      this.desativaAposSolicitarArquivo = false;
    }
    ,() => {
      this.desativaAposSolicitarArquivo = false;
    });
  }

  exibirLoading(mostrar: boolean) {
    const overlay = document.getElementById('overlay');
    if(overlay){
      overlay.style.display = mostrar ? 'block' : 'none';
    }
  }

  deletarArquivo(id) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente excluir o documento?'
    this.bsModalRef.content.confirmar = () => {
      this.exibirLoading(true);
      this.processoService.deletarDocumento(id).toPromise()
      .then(
        () => {})
      .catch(
        () => {
          this.toastrService.error("Não foi possível excluir o documento selecionado.", "Erro");
        })
      .finally(
        () => {
          this.exibirLoading(false);
          this.processoService.obterDocumentos(this.processoId).toPromise().then((documento) => this.lstProcessoAnexo = documento);
        })
    };
  }

}
